import Dashboard from 'components/dashboard/user/Dashboard';

export default function UserRoute() {
  return (
    <Dashboard/>
  );
}
